import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Table, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import RenewalVisualization from './RenewalVisualization';
const RenewalDecisionTable = ({ data, flag, brand, model, country, result }) => {
    // Define columns in the same component
    const [isModalVisible, setIsModalVisible] = useState(false); // Modal visibility state
    const [modalContent, setModalContent] = useState(''); // Content to display in the modal
    const showModal = (content) => {
        setModalContent(content);
        setIsModalVisible(true);
    };
    const findRenewalUnDecided = (id) => {
        const item = result.find(entry => entry.intId === id);
        return item ? item === null || item === void 0 ? void 0 : item.intRenewalUnDecided : null;
    };
    const handleModalClose = () => {
        setIsModalVisible(false);
    };
    const basicColumns = [
        {
            title: '',
            dataIndex: 'date',
            key: 'date',
            width: 90,
            //render: (text: any) => <span style={{ border: 'none' }}>{text}</span>
            render: (value, record) => {
                if (flag != 1) {
                    return (_jsx("span", { children: _jsx(Link, { to: `/certificates?key=${getKey(record === null || record === void 0 ? void 0 : record.key, flag) || ''}&b=${(brand === null || brand === void 0 ? void 0 : brand.intId) || ''}&m=${model || ''}&c=${(country === null || country === void 0 ? void 0 : country.intId) || ''}&q=${flag - 1}&ct=${(findRenewalUnDecided(getKey(record === null || record === void 0 ? void 0 : record.key, flag))) || ''}`, target: "_blank", children: value || '' }) }));
                }
                else {
                    return (_jsx("span", { children: value || '' }));
                }
            }
        },
        {
            title: 'Total',
            dataIndex: 'total',
            width: 50,
            key: 'total'
        }
    ];
    const mColumns = flag !== 1
        ? [
            ...basicColumns,
            {
                title: 'Undecided',
                dataIndex: 'undecided',
                width: 80,
                key: 'undecided',
                render: (value, record) => {
                    if (record.date !== 'Over 180 Days' &&
                        record.date !== 'Indefinite' &&
                        record.date !== 'Cancelled')
                        return _jsx("span", { children: value });
                }
            },
            {
                title: 'Decided',
                dataIndex: 'decided',
                key: 'decided',
                width: 60,
                render: (value, record) => {
                    if (record.date !== 'Indefinite' &&
                        record.date !== 'Over 180 Days' &&
                        record.date !== 'Cancelled')
                        if (value !== 0)
                            return (_jsx(Tooltip, { title: tooltipContent(getKey(record === null || record === void 0 ? void 0 : record.key, flag)), style: {
                                    backgroundColor: 'white',
                                    padding: 0,
                                }, placement: "topLeft", overlayStyle: {
                                    wordWrap: 'break-word',
                                    whiteSpace: 'normal',
                                }, children: _jsx("span", { children: _jsx("a", { style: {
                                            textDecoration: "underline",
                                        }, children: value }) }) }));
                        else {
                            return _jsx("span", { children: _jsx("a", { href: value }) });
                        }
                },
            },
        ]
        : basicColumns;
    const modifiedColumns = flag === 1
        ? [
            ...mColumns,
            {
                title: 'Started',
                dataIndex: 'started',
                width: 50,
                key: 'started',
                render: (value, record) => {
                    if (record.date !== 'Over 180 Days' &&
                        record.date !== 'Cancelled' &&
                        record.date !== 'On Hold')
                        return _jsx("span", { children: value });
                }
            },
            {
                title: 'Not Started',
                dataIndex: 'notStarted',
                key: 'notStarted',
                width: 60,
                render: (value, record) => {
                    if (record.date !== 'Over 180 Days' &&
                        record.date !== 'Cancelled' &&
                        record.date !== 'On Hold')
                        return _jsx("span", { children: value });
                }
            }
        ]
        : mColumns;
    const transformedData = Array.from(new Set(data.map((item) => item.date))).map((date) => {
        var _a, _b, _c, _d, _e;
        const total = ((_a = data.find((item) => item.date === date && item.type === 'Total')) === null || _a === void 0 ? void 0 : _a.value) || 0;
        if (flag !== 1) {
            const undecided = ((_b = data.find((item) => item.date === date && item.type === 'Undecided')) === null || _b === void 0 ? void 0 : _b.value) || 0;
            const decided = ((_c = data.find((item) => item.date === date && item.type === 'Decided')) === null || _c === void 0 ? void 0 : _c.value) || 0;
            return { key: date, date, total, undecided, decided };
        }
        else {
            const started = ((_d = data.find((item) => item.date === date && item.type === 'Started')) === null || _d === void 0 ? void 0 : _d.value) || 0;
            const notStarted = ((_e = data.find((item) => item.date === date && item.type === 'Not Started')) === null || _e === void 0 ? void 0 : _e.value) || 0;
            return { key: date, date, total, started, notStarted };
        }
    });
    const tooltipContent = (key) => {
        return (_jsx("div", { style: {
                width: '400px',
                height: '300px',
                backgroundColor: 'white',
                padding: '16px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                borderRadius: '4px',
            }, children: _jsx(RenewalVisualization, { data: data, flag: flag, brand: brand, model: model, country: country, result: result, keyFlag: key }) }));
    };
    return (_jsx(_Fragment, { children: _jsx(Table, { dataSource: transformedData, columns: modifiedColumns, pagination: false, bordered: true, size: "small", tableLayout: "fixed", components: {
                body: {
                    row: (props) => (_jsx("tr", Object.assign({}, props, { style: { padding: '4px 8px', height: '30px' } }))),
                    cell: (props) => (_jsx("td", Object.assign({}, props, { style: { padding: '4px 8px', height: '30px', fontSize: '12px' } })))
                }
            } }) }));
};
export default RenewalDecisionTable;
function getKey(key, flag) {
    if (key === 'Indefinite' && flag === 2)
        return 110;
    if (key === 'Over 180 Days' && flag === 2)
        return 120;
    if (key === '91-180 Days' && flag === 2)
        return 130;
    if (key === '61-90 Days' && flag === 2)
        return 140;
    if (key === '31-60 Days' && flag === 2)
        return 150;
    if (key === '11-30 Days' && flag === 2)
        return 160;
    if (key === '1-10 Days' && flag === 2)
        return 165;
    if (key === 'Overdue' && flag === 2)
        return 170;
    if (key === 'Cancelled' && flag === 2)
        return 180;
    if (key === 'Indefinite' && flag === 3)
        return 210;
    if (key === 'Over 180 Days' && flag === 3)
        return 220;
    if (key === '91-180 Days' && flag === 3)
        return 230;
    if (key === '61-90 Days' && flag === 3)
        return 240;
    if (key === '31-60 Days' && flag === 3)
        return 250;
    if (key === '11-30 Days' && flag === 3)
        return 260;
    if (key === '1-10 Days' && flag === 3)
        return 270;
    if (key === 'Expired' && flag === 3)
        return 280;
    if (key === 'Cancelled' && flag === 3)
        return 290;
}
